// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var WebStore = require("../../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var WebTypes_View = require("../../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebContainers_BusinessDashboard_Settings_Admins = require("./WebContainers_BusinessDashboard_Settings_Admins.bs.js");
var WebContainers_BusinessDashboard_Settings_Managers = require("./WebContainers_BusinessDashboard_Settings_Managers.bs.js");
var WebContainers_BusinessDashboard_Settings_Locations = require("./WebContainers_BusinessDashboard_Settings_Locations.bs.js");

function text(isSelected) {
  var arg = function (param) {
    return BrowserStyle.withFont(param, /* Quicksand */0, /* Medium */3, /* Bold */2);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
                  hd: BrowserStyle.color(isSelected ? ({
                            TAG: /* Grey */2,
                            _0: /* Darkest */0
                          }) : ({
                            TAG: /* Grey */2,
                            _0: /* Medium */2
                          })),
                  tl: /* [] */0
                }));
}

var Styles = {
  text: text
};

function WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabs$Tab(Props) {
  var text$1 = Props.text;
  var isSelected = Props.isSelected;
  var onSelect = Props.onSelect;
  var testId = Props.testId;
  var tmp = {
    children: React.createElement(BrowserComponents_Text.make, {
          className: text(isSelected),
          children: text$1
        }),
    onClick: (function (param) {
        return onSelect;
      })
  };
  if (testId !== undefined) {
    tmp.testId = Caml_option.valFromOption(testId);
  }
  return React.createElement(BrowserComponents_Button.Base.make, tmp);
}

var Tab = {
  Styles: Styles,
  make: WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabs$Tab
};

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.borderBottom(BrowserStyle.rem(0.0625), "solid", {
            TAG: /* Grey */2,
            _0: /* Light */3
          }),
      tl: {
        hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.small),
        tl: /* [] */0
      }
    });

var Styles$1 = {
  container: container
};

function WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabs(Props) {
  var currentSettingsView = Props.currentSettingsView;
  var onSelect = Props.onSelect;
  var tmp;
  switch (currentSettingsView.TAG | 0) {
    case /* Admins */0 :
        tmp = true;
        break;
    case /* Managers */1 :
    case /* Locations */2 :
        tmp = false;
        break;
    
  }
  var tmp$1;
  switch (currentSettingsView.TAG | 0) {
    case /* Managers */1 :
        tmp$1 = true;
        break;
    case /* Admins */0 :
    case /* Locations */2 :
        tmp$1 = false;
        break;
    
  }
  var tmp$2;
  switch (currentSettingsView.TAG | 0) {
    case /* Admins */0 :
    case /* Managers */1 :
        tmp$2 = false;
        break;
    case /* Locations */2 :
        tmp$2 = true;
        break;
    
  }
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: container,
              children: null
            }, React.createElement(WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabs$Tab, {
                  text: "Admins",
                  isSelected: tmp,
                  onSelect: Curry._1(onSelect, {
                        TAG: /* Admins */0,
                        _0: /* Viewing */0
                      }),
                  testId: "adminsTab"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabs$Tab, {
                  text: "On-Site Managers",
                  isSelected: tmp$1,
                  onSelect: Curry._1(onSelect, {
                        TAG: /* Managers */1,
                        _0: /* Viewing */0
                      }),
                  testId: "onSiteManagersTab"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabs$Tab, {
                  text: "Locations",
                  isSelected: tmp$2,
                  onSelect: Curry._1(onSelect, {
                        TAG: /* Locations */2,
                        _0: /* Viewing */0
                      }),
                  testId: "locationTab"
                }));
}

var SettingsTabs = {
  Tab: Tab,
  Styles: Styles$1,
  make: WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabs
};

function WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabView(Props) {
  var currentSettingsView = Props.currentSettingsView;
  var setSettingsPageView = Props.setSettingsPageView;
  var user = Props.user;
  switch (currentSettingsView.TAG | 0) {
    case /* Admins */0 :
        return React.createElement(WebContainers_BusinessDashboard_Settings_Admins.make, {
                    setSettingsPageView: (function (param) {
                        return Relude_Globals.$great$great(WebTypes_View.BusinessDashboard.Settings.admins, setSettingsPageView, param);
                      }),
                    subPage: currentSettingsView._0,
                    user: user
                  });
    case /* Managers */1 :
        return React.createElement(WebContainers_BusinessDashboard_Settings_Managers.make, {
                    subPage: currentSettingsView._0,
                    setSettingsPageView: (function (param) {
                        return Relude_Globals.$great$great(WebTypes_View.BusinessDashboard.Settings.managers, setSettingsPageView, param);
                      })
                  });
    case /* Locations */2 :
        return React.createElement(WebContainers_BusinessDashboard_Settings_Locations.make, {
                    subPage: currentSettingsView._0,
                    setSettingsPageView: (function (param) {
                        return Relude_Globals.$great$great(WebTypes_View.BusinessDashboard.Settings.locations, setSettingsPageView, param);
                      })
                  });
    
  }
}

var SettingsTabView = {
  make: WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabView
};

var container$1 = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.display("flex"),
          tl: {
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: {
              hd: BrowserStyle.flexDirection(BrowserStyle.row),
              tl: {
                hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
                tl: {
                  hd: BrowserStyle.justifyContent(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.mobileMedia({
                          hd: BrowserStyle.justifyContent(BrowserStyle.stretch),
                          tl: {
                            hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                            tl: /* [] */0
                          }
                        }),
                    tl: {
                      hd: BrowserStyle.padding2(BrowserStyle.Spacing.large, BrowserStyle.zero),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }));

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XXLarge */6, /* Bold */2);
}

var businessName = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Darkest */0
              }),
          tl: /* [] */0
        }));

var content = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexBasis(BrowserStyle.pct(50.0)),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.flexBasis(BrowserStyle.pct(100.0)),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var Styles$2 = {
  container: container$1,
  businessName: businessName,
  content: content
};

function WebContainers_BusinessDashboard_Settings$Presentation(Props) {
  var currentSettingsView = Props.currentSettingsView;
  var setView = Props.setView;
  var user = Props.user;
  var setSettingsPageView = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(WebTypes_View.BusinessDashboard.settings, WebTypes_View.businessDashboard, param);
                }), setView, param);
  };
  return React.createElement("main", {
              className: container$1
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  className: content,
                  children: null
                }, React.createElement(BrowserComponents_Text.make, {
                      className: businessName,
                      children: user.business.businessName
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabs, {
                      currentSettingsView: currentSettingsView,
                      onSelect: setSettingsPageView
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Small */3
                    }), React.createElement(WebContainers_BusinessDashboard_Settings$Presentation$SettingsTabView, {
                      currentSettingsView: currentSettingsView,
                      setSettingsPageView: setSettingsPageView,
                      user: user
                    })));
}

var Presentation = {
  SettingsTabs: SettingsTabs,
  SettingsTabView: SettingsTabView,
  Styles: Styles$2,
  make: WebContainers_BusinessDashboard_Settings$Presentation
};

function mapStateToProps(prim) {
  
}

function mapDispatchToProps(dispatch, _stateProps) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  return {
          setView: (function (param) {
              return Relude_Globals.$great$great((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.setView, dispatch, param);
                          }), partial_arg, param);
            })
        };
}

function WebContainers_BusinessDashboard_Settings(Props) {
  var currentSettingsView = Props.currentSettingsView;
  var user = Props.user;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_BusinessDashboard_Settings$Presentation, {
                              currentSettingsView: currentSettingsView,
                              setView: param$1.setView,
                              user: user
                            });
                })
            });
}

var make = WebContainers_BusinessDashboard_Settings;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* container Not a pure module */
